import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import Header from "src/components/UI/Header/Header";
import VerticalNavBar from "src/components/UI/VerticalNavBar/VerticalNavBar";
import { ManagementsAdmins } from "src/ManagementsAdminNavigation";
import { RootState } from "src/redux/store";

type Props = {
  children?: React.ReactNode | string;
};

const ManagementAdminsLayouts = ({ children }: Props) => {
  
  const { isCollapsed }: any = useSelector(
    (state: RootState) => state.financeLayout
  );

  const toggleCollapse = () => { };
  const location = useLocation();
  const currentPath = `${location.pathname?.split("/")[2]}`;

  return (
    <div className="flex h-screen w-screen relative" tabIndex={0}>
      {/* Side Navigation Bar */}
      <VerticalNavBar
        toggleCollapse={toggleCollapse}
        isCollapsed={isCollapsed}
        navigation={ManagementsAdmins}
        isPathEqualtoNavItem={(navItem: any) => navItem.path === currentPath}
      />

      <div
        className={`h-full flex flex-col transition-all duration-500 ${isCollapsed ? "w-full" : "w-[calc(100%-230px)]"
          } `}
      >
        {/* Header */}
        <div className="h-[50px]">
          <Header toggleCollapse={toggleCollapse} isCollapsed={isCollapsed} />
        </div>

        <div className="flex-1 overflow-auto">
          <Outlet />
        </div>
      </div>

    </div>
  );
};

export default ManagementAdminsLayouts;
